import styled, { css } from 'styled-components';
import { NavLink } from 'modules/Core/Common';
import { device } from 'modules/Utils/Devices';

const MenuItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${(props) => (props.$expanded ? '8px' : '12px')};
  width: ${(props) => (props.$expanded ? '100%' : '48px')};
  height: ${(props) => (props.$expanded ? 'auto' : '48px')};
  justify-content: ${(props) => (props.$expanded ? 'flex-start' : 'center')};
  border-radius: 4px;
  color: ${(props) => props.theme.config.colors.primary_100};
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.config.colors.secondary_700};
    color: ${(props) => props.theme.config.colors.primary_100};
  }

  &.active {
    background-color: ${(props) => props.theme.config.colors.secondary_700};
    color: ${(props) => props.theme.config.colors.primary};

    svg path {
      fill: ${(props) => props.theme.config.colors.primary};
    }
  }

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5;
    `}

  @media ${device.tabletMin} {
    &:hover svg path {
      fill: ${(props) => props.theme.config.colors.primary_100};
    }

    &.active:hover svg path {
      fill: ${(props) => props.theme.config.colors.primary};
    }
  }

  @media ${device.mobile} {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 24px;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  svg {
    width: 24px;
    height: 24px;
  }

  svg path {
    fill: ${(props) => props.theme.config.colors.primary_300};
  }
`;

const Label = styled.span`
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { MenuItem, IconWrapper, Label };
